// ProtectedRoute.tsx
import {NavLink, Outlet, useOutletContext} from 'react-router-dom'
import {OutletContexParams} from "../pages/Layout";

const ProtectedRoute: React.FC<{ isTrust: boolean }> = ({isTrust}) => {
    const params = useOutletContext<OutletContexParams>();

    // show unauthorized screen if no user is found in redux store
    if (!isTrust) {
        return (
            <div className='unauthorized'>
                <h1>Unauthorized :(</h1>
                <span>
                    <NavLink to='/login'>Login</NavLink> to gain access
                </span>
            </div>
        )
    }
    //console.log('ProtectedRoute: params', params);

    // returns child route elements
    return <Outlet context={params}/>
}
export default ProtectedRoute